import React from 'react';
import { View } from 'react-native-web';
import ColorContainer from './ColorContainer';
import Title from '../Text/Title';

//= ========================================================================

const ColorsMenu = ({
  globJSON,
  onConfigChanged,
  headline,
  colorList,
}) => (
  <View>
    <Title>{headline}</Title>
    <View style={{
      flexDirection: 'row', flexWrap: 'wrap', gap: 20, marginBottom: 20,
    }}
    >
      {colorList.map((colorKey) => <ColorContainer globJSON={globJSON} onConfigChanged={onConfigChanged} colorKey={colorKey} />)}
    </View>
  </View>

);
export default ColorsMenu;
